/**
 * @generated SignedSource<<65a654ed5287106472548e86a1bde0a9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TodoAssigneesPopover_EmployeeItem$data = {
  readonly id: string;
  readonly name: string;
  readonly " $fragmentSpreads": FragmentRefs<"Avatar_employee">;
  readonly " $fragmentType": "TodoAssigneesPopover_EmployeeItem";
};
export type TodoAssigneesPopover_EmployeeItem$key = {
  readonly " $data"?: TodoAssigneesPopover_EmployeeItem$data;
  readonly " $fragmentSpreads": FragmentRefs<"TodoAssigneesPopover_EmployeeItem">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TodoAssigneesPopover_EmployeeItem",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "Avatar_employee"
    }
  ],
  "type": "Employee",
  "abstractKey": null
};

(node as any).hash = "e78eec5b6cd36a48f7bc1015ab113002";

export default node;
